module.exports = __webpack_public_path__ + "b4f401e17adfd34243237b724ff7269c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-photo/img/summary-diamond-placeholder-external@2x.png
// module id = 752
// module chunks = 0